import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import ErrorBoundary from './Components/Containers/ErrorBoundary/ErrorBoundary';
import './Services/Sentry';

const root = createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <ErrorBoundary fullPage={true}>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

window.statusBar = (device) => {
  if (device) {
    window.localStorage.setItem('statusBar', device);
  } else {
    window.localStorage.removeItem('statusBar');
  }
}

window.roleOverride = (role) => {
  if (role) {
    window.localStorage.setItem('roleOverride', role);
  } else {
    window.localStorage.removeItem('roleOverride');
  }

  window.location.reload();
}

window.toggleAdmin = () => {
  if (window.localStorage.getItem('adminDisabled')) {
    window.localStorage.removeItem('adminDisabled');
  } else {
    window.localStorage.setItem('adminDisabled', 'true');
  }

  window.location.reload();
}

window.toggleChallengeLogin = () => {
  if (window.localStorage.getItem('challengeLogin')) {
    window.localStorage.removeItem('challengeLogin');
  } else {
    window.localStorage.setItem('challengeLogin', 'true');
  }

  window.location.reload();
}
